import { Link } from 'react-router-dom'
import { cn } from '../lib/utils'

interface ShelfHeaderProps {
  title: string
  /** 可选副标题；App Store 多数 shelf 只有标题 */
  subtitle?: string
  seeAllHref?: string
  seeAllLabel?: string
  className?: string
}

/**
 * App Store web shelf 标题行：左侧大标题，右侧蓝色「查看全部」
 */
export function ShelfHeader({
  title,
  subtitle,
  seeAllHref,
  seeAllLabel = '查看全部',
  className,
}: ShelfHeaderProps) {
  return (
    <div className={cn('flex items-end justify-between gap-4 mb-3', className)}>
      <div className="min-w-0">
        <h2 className="text-[21px] md:text-[22px] font-bold tracking-tight leading-tight truncate">
          {title}
        </h2>
        {subtitle ? (
          <p className="text-[13px] text-muted-foreground mt-0.5 line-clamp-1">{subtitle}</p>
        ) : null}
      </div>
      {seeAllHref ? (
        <Link
          to={seeAllHref}
          className="text-primary text-[15px] font-normal shrink-0 hover:underline underline-offset-2"
        >
          {seeAllLabel}
        </Link>
      ) : null}
    </div>
  )
}
